import type { SearchResponse } from "src/api/SearchResponse";
import { createTransportKey } from "./createTransportKey";

export function getSearchTransportKey(searchResponse: SearchResponse) {
  const origin = searchResponse?.places[0]?.canonicalName;
  const destination = searchResponse?.places[1]?.canonicalName;
  return createTransportKey(origin!, destination!);
}
